<template>
    <div class="user-groups-page">
        <Toast />
        <ConfirmDialog />

        <div class="user-groups-page__header">
            <h4 class="user-groups-page__title">Brukergrupper</h4>
            <Button label="Legg til gruppe" icon="pi pi-plus" size="small" @click="openCreateDialog" />
        </div>

        <Message v-if="!loading && groups.length === 0" severity="info" :closable="false">
            Ingen brukergrupper finnes ennå.
        </Message>

        <template v-else>
            <IconField class="user-groups-page__search">
                <InputIcon class="pi pi-search" />
                <InputText v-model="search" placeholder="Søk etter navn" style="width: 100%" />
            </IconField>

            <DataTable :value="filteredGroups" :loading="loading" dataKey="id" stripedRows class="user-groups-page__table">
                <Column field="name" header="Navn">
                    <template #body="{ data }">
                        <button type="button" class="user-groups-page__name-link" @click="openEditDialog(data)">
                            {{ data.name }}
                        </button>
                    </template>
                </Column>
                <Column field="users_count" header="Antall brukere" />
                <template #empty>
                    Ingen brukergrupper funnet.
                </template>
            </DataTable>
        </template>

        <UserGroupEditDialog
            v-model:visible="showFormDialog"
            :group="editingGroup"
            :all-users="allUsers"
            @saved="upsertGroup"
            @deleted="removeGroupFromList"
            @member-count-changed="adjustUsersCount"
        />
    </div>
</template>
<script>
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import UserGroupEditDialog from './UserGroupEditDialog';

export default {
    components: {
        Button,
        DataTable,
        Column,
        InputText,
        Message,
        Toast,
        ConfirmDialog,
        IconField,
        InputIcon,
        UserGroupEditDialog,
    },
    data() {
        return {
            groups: [],
            allUsers: [],
            search: '',
            loading: true,
            showFormDialog: false,
            editingGroup: null,
        };
    },
    computed: {
        filteredGroups() {
            const term = this.search.trim().toLowerCase();

            if (!term) {
                return this.groups;
            }

            return this.groups.filter(group => group.name.toLowerCase().includes(term));
        },
    },
    mounted() {
        this.fetchGroups();
        this.fetchUsers();
    },
    methods: {
        async fetchGroups() {
            try {
                const response = await fetch('/api/v1/usergroup');
                this.groups = await response.json();
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        async fetchUsers() {
            try {
                const response = await fetch('/api/v1/user');
                this.allUsers = await response.json();
            } catch (error) {
                console.error(error);
            }
        },
        openCreateDialog() {
            this.editingGroup = null;
            this.showFormDialog = true;
        },
        openEditDialog(group) {
            this.editingGroup = group;
            this.showFormDialog = true;
        },
        upsertGroup(group) {
            const index = this.groups.findIndex(g => g.id === group.id);
            if (index !== -1) {
                this.groups.splice(index, 1, { ...this.groups[index], ...group });
            } else {
                this.groups.push(group);
            }
        },
        removeGroupFromList(groupId) {
            this.groups = this.groups.filter(g => g.id !== groupId);
        },
        adjustUsersCount({ groupId, delta }) {
            const index = this.groups.findIndex(g => g.id === groupId);
            if (index !== -1) {
                this.groups[index].users_count += delta;
            }
        },
    },
};
</script>
<style scoped>
.user-groups-page__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.user-groups-page__title {
    margin: 0;
}

.user-groups-page__search {
    display: block;
    max-width: 320px;
    margin-bottom: 1rem;
}

.user-groups-page__name-link {
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    color: var(--p-primary-color, #3b82f6);
    cursor: pointer;
    text-decoration: none;
}

.user-groups-page__name-link:hover {
    text-decoration: underline;
}
</style>
